<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
function t() {
  try {
    var a = ["r", "e", "g", "g", "u", "b", "e", "d"].reverse().join("");
    !function e(n) {
      (1 !== ("" + n / n).length || 0 === n) && function () {
      }
        .constructor(a)(),
        e(++n)
    }(0)
  } catch (a) {
    setTimeout(t, 200)
  }
}

export default {
  name: 'App',
  data() {
    return {
      isMobile: false
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || false;
    }
  },
  created() {
    // this.checkMobile()
    // console.log('isMobile:'+this.isMobile)
    // if (!this.isMobile) {
    //   this.$router.push({
    //     path: '/Home'
    //   })
    // } else {
    //   this.$router.push({
    //     path: '/MobileHome'
    //   })
    // }
    // t()
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1600px;
}

.van-dropdown-menu__bar {
  box-shadow: unset !important;
  background-color: white !important;
}

.van-dropdown-menu__title {
  font-size: 12px !important;
}

.van-dropdown-item__option {
  font-size: 12px !important;
  line-height: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue